import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { CancelSaleModal } from 'features/Sales/components/CancelSaleModal'
import { SALE_STATUS } from 'features/Sales/components/Status/constants'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canCancel } from 'features/Users/utils'
import { GTSale } from 'gql/types.generated'
import { useLogin } from 'features/Login/hooks'
import IconButton from 'components/v2/IconButton'

export const SaleActions = ({ sale }: { sale: GTSale }): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenCancelSaleModal, setOpenCancelSaleModal] = useState(false)

  const login = useLogin()

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const canCancelSale = canCancel(FEATURES.SALE, login.accessToken.policies) && sale.status !== SALE_STATUS.CANCELLED

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item
              action
              onClick={(): TSFixMe => {
                if (canCancelSale) {
                  setOpenDropdown(false)
                  setOpenCancelSaleModal(true)
                }
              }}
              disabled={!canCancelSale}
            >
              <FormattedMessage id="spanish.dictionary.cancel" defaultMessage="Cancelar" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
      {isOpenCancelSaleModal && <CancelSaleModal sale={sale} closeModal={(): void => setOpenCancelSaleModal(false)} />}
    </>
  )
}
